export enum AxAIGroqModel {
  Llama3_8B = 'llama3-8b-8192',
  Llama33_70B = 'llama-3.3-70b-versatile',
  Mixtral_8x7B = 'mixtral-8x7b-32768',
  Gemma2_9B = 'gemma2-9b-it',
}
